/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import kitsu from '@plugins/kitsu';

const opt = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  baseURL: process.env.VUE_APP_API_URL + '/psp/gtk',
};
const $ajax = kitsu(opt);

export const state = {
  detail: null,
  opsi: null,
  meta: null,
};

export const mutations = {
  SET_DETAIL(state, newValue) {
    state.detail = newValue;
  },
  SET_OPSI(state, newValue) {
    state.opsi = newValue;
  },
  SET_META(state, newValue) {
    state.meta = newValue;
  },
};

export const actions = {
  async fetch({ commit }, { id, reset }) {
    if (state.detail && !reset) return Promise.resolve(state.detail);
    const detail = await $ajax.get(`profil/${id}`).then((data) => data);
    commit('SET_DETAIL', detail?.data ?? {});
    commit('SET_META', detail?.meta ?? {});
    return Promise.resolve(detail);
  },

  async option({ commit }, id) {
    if (state.opsi) return Promise.resolve(state.opsi);
    const { data } = await http.get(`psp/gtk/profil/${id}/opsi`).then(({ data }) => data);
    commit('SET_OPSI', data);
    return Promise.resolve(data);
  },

  mulaiCv({}, id) {
    const url = `psp/gtk/profil/${id}/mulai-cv`;
    return http.post(url);
  },

  saveProfil({}, { id, params, tipe }) {
    const url = `psp/gtk/profil/${id}/save${tipe ? `-${tipe}` : ''}`;
    return http.post(url, params);
  },

  upload({}, { id, params }) {
    const url = `psp/gtk/profil/${id}/berkas-insert`;
    return http.post(url, params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  uploadPakta({}, { id, params }) {
    const url = `psp/gtk/profil/${id}/upload-pakta`;
    return http.post(url, params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};
